import React from "react";
import { MetaDataMethodCode } from "../../types/MetaDataMethodCode";
import { sweetalert } from "../../App";
import { isBlank, isOnlyWhitespace } from "../../util/ValidationUtil";
import { buildRow, getBoolSelectVal } from "../../util/FormatUtil";
import { isEmptyObject } from "jquery";
import Select from "react-select";
import GetField from "../../customfields/GetField";
import { CustomFieldBuilder } from "../../customfields/CustomFieldBuilder";
import { getFieldReadOnly, FieldPermissions } from "../../util/RolePermissions";

interface MethodCodeManagementState {
  selectedMethodCode: MetaDataMethodCode
}
interface MethodCodeManagementProps {
  selectedMethodCode: MetaDataMethodCode
  onSubmit?
  pageCustomQuestions?
  userRoles?
  fieldPermissions?: FieldPermissions
}
export class MethodCodeManagementModal extends React.Component<MethodCodeManagementProps, MethodCodeManagementState> {
  public static ID = "methodcodemanagement";
  constructor(props) {
    super(props);
    this.state = {
      selectedMethodCode: {
        ID: null,
        Name: "",
        Description: "",
        Active: null,
      } as MetaDataMethodCode
    } as MethodCodeManagementState
  }

  componentDidMount(): void {
    $(`#${MethodCodeManagementModal.ID}`).on('shown.bs.modal', function () {
      $(document).off('focusin.modal');
    });
  }

  componentWillReceiveProps(nextProps: Readonly<MethodCodeManagementProps>, nextContext: any) {
    if (!isEmptyObject(nextProps.selectedMethodCode)) {
      let result = nextProps.selectedMethodCode;
      console.log(" result ? ", result)
      this.setState({
        selectedMethodCode: {
          ID: result.ID ? result.ID : null,
          Name: result.Name ? result.Name : "",
          Description: result.Description ? result.Description : "",
          Active: result.Active ? result.Active : null,
          CreatedDate: result.CreatedDate ? result.CreatedDate : null,
          CreatedBy: result.CreatedBy ? result.CreatedBy : "",
          UpdatedDate: result.UpdatedDate ? result.UpdatedDate : null,
          UpdatedBy: result.UpdatedBy ? result.UpdatedBy : "",
          CustomFieldData: result.CustomFieldData ? JSON.parse(result.CustomFieldData) : [],
        } as MetaDataMethodCode
      });
    }
  }

  render() {
    return (
      <div className="modal fade form_modal" id={MethodCodeManagementModal.ID} tabIndex={-1} role="dialog"
        aria-labelledby="result_modal_label"
        aria-hidden="true">
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="result_modal_label">Method Code Management</h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {buildRow("Name",
                  <input className={"form-control"}
                    id="Name"
                    maxLength={50}
                    // readOnly={this.state.selectedMethodCode.ID != null}
                    autoComplete={"off"}
                    type={"search"}
                    name={"Name"}
                    aria-label="Name"
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedMethodCode: {
                          ...prevState.selectedMethodCode,
                          Name: e.target.value
                        }
                      }))
                    }}
                    value={this.state.selectedMethodCode.Name}
                  />, 'Name', true
                )}
                {buildRow("Description",
                  <input className={"form-control"}
                    id="Description"
                    maxLength={50}
                    autoComplete={"off"}
                    type={"search"}
                    name={"Description"}
                    aria-label="Description"
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedMethodCode: {
                          ...prevState.selectedMethodCode,
                          Description: e.target.value
                        }
                      }))
                    }}
                    value={this.state.selectedMethodCode.Description}
                  />, 'Description'
                )}
                {buildRow("Active?",
                  <Select
                    aria-label="Active?"
                    isSearchable={true}
                    placeholder={"Please Select..."}
                    noOptionsMessage={() => "No option"}
                    value={this.state.selectedMethodCode.ID ? getBoolSelectVal(this.state.selectedMethodCode.Active) :
                      this.state.selectedMethodCode.Active === 1 || this.state.selectedMethodCode.Active === 0 ? getBoolSelectVal(this.state.selectedMethodCode.Active) :
                        null}
                    onChange={(e) => this.setState((prevState) => ({
                      selectedMethodCode: {
                        ...prevState.selectedMethodCode,
                        Active: e.value ? 1 : 0
                      }
                    }))}
                    className={"state_select"}
                    options={[{ label: "Yes", value: true }, { label: "No", value: false }]}
                  />, 'Active?', true
                )}
                {/*Custom Field Data*/}

                {
                  (this.props.pageCustomQuestions)
                    ?
                    <div className="row">
                      {this.props.pageCustomQuestions.map((val, index) => {
                        if (val.Options.isActive) {
                          return (
                            <div className="col-12">
                              <div className="form-group row">
                                <GetField
                                  val={val}
                                  isRequired={val.Options.isRequired}
                                  readOnly={getFieldReadOnly(val.DisplayName, this.props.userRoles, this.props.fieldPermissions)}
                                  selectedItem={this.state.selectedMethodCode ? this.state.selectedMethodCode : null}
                                  handleChange={(e) => {
                                    this.setState({ selectedMethodCode: e })
                                  }}
                                />
                              </div>
                            </div>
                          )
                        } else { return <></> }
                      })}
                    </div>
                    :
                    <div className="invisible"></div>
                }

              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={() => {
                  if (isBlank(this.state.selectedMethodCode.Name) ||
                    isOnlyWhitespace(this.state.selectedMethodCode.Name)
                  ) {
                    return sweetalert.fire("Attention", "Name cannot be empty.", "error")
                  }
                  if (this.state.selectedMethodCode.Active === null && this.state.selectedMethodCode.ID === null) {
                    return sweetalert.fire("Attention", "Active cannot be empty.", "error")
                  }
                  let invalid = CustomFieldBuilder.validateCustomFields(this.state.selectedMethodCode.CustomFieldData, this.props.pageCustomQuestions, this.state.selectedMethodCode)

                  if (invalid) {
                    return;
                  }
                  this.props.onSubmit(this.state.selectedMethodCode);
                }}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}